export enum IconButtonSize {
  SMALL = 'icon-button-small',
  MEDIUM = 'icon-button-medium',
  LARGE = 'icon-button-large',
}

export enum IconButtonTheme {
  PRIMARY_ACCENT = 'primary-accent',
  SECONDARY_OUTLINE = 'secondary-outline',
  SECONDARY_OUTLINE_REVERSED = 'secondary-outline-reversed',
  TERTIARY_GHOST = 'tertiary-ghost',
  TERTIARY_GHOST_REVERSED = 'tertiary-ghost-reversed',
}
